import React from 'react';

import List from './country/List'

function Country(){
	return(
		
			<List/>
			
	
	);
}

export default Country;